// // if ($('.top-hero').length) {
// //   $('body').scroll(function () {
// //     var scroll = $(this).scrollTop() + 'px';
// //   });
// // }

// $('.js-modal-trigger').click(function () {
//   // var select_num = $(this).data('modal');
//   // console.log(select_num);
//   $('.modal-contents').addClass('is-open');
//   $('html').css({
//     'position': 'fixed',
//     'top': '100px',
//     'width': '100%',
//     'height': '100%',
//     'overflow': 'hidden'
//   });

//   $(window).scrollTop($("html").data("scrTop"));
// });

// $('.modal-contents__cancel').click(function () {
//   // console.log('1234567890');
//   $('.modal-contents').removeClass('is-open');
//   $('html').css({
//     'position': '',
//     'top': '',
//     'width': '',
//     'height': '',
//     'overflow': ''
//   });
// });

